<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Tag color="blue">广东税务云 · 单位社保费申报</Tag>
      </Cell>
      <Cell>
        <DatePicker v-model="year" type="year" format="yyyy" style="width:110px" placeholder="年度"></DatePicker>
      </Cell>
      <Cell>
        <Select v-model="month" style="width:90px" placeholder="月份">
          <Option v-for="m in 12" :value="m" :key="m">{{ m }}月</Option>
        </Select>
      </Cell>
      <Cell>
        <Button color="primary" @click="doPreview" :loading="loading">申报预览</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="doSubmit" :loading="submitting" :disabled="!rows.length">申报提交</Button>
      </Cell>
    </Row>

    <Alert class="margin-right-left margin-top" type="info">
      广东单位参考费率：养老 {{ rates.pension * 100 }}%、医疗 {{ rates.medical * 100 }}%、失业 {{ rates.unemployment * 100 }}%、
      工伤 {{ rates.injury * 100 }}%（浮动费率）；广东生育已并入医疗。具体以参保地税务/社保政策为准。
    </Alert>

    <!--预览表-->
    <div class="h-panel-body padding-top">
      <Table :datas="rows" :border="true" :loading="loading">
        <TableItem title="姓名" prop="name" :width="100"></TableItem>
        <TableItem title="证件号码" prop="certNo" :width="170"></TableItem>
        <TableItem title="缴费工资" align="right">
          <template slot-scope="{data}">{{ money(data.declareWage) }}</template>
        </TableItem>
        <TableItem title="养老保险" align="right">
          <template slot-scope="{data}">{{ money(data.pension) }}</template>
        </TableItem>
        <TableItem title="医疗保险(含生育)" align="right">
          <template slot-scope="{data}">{{ money(data.medical) }}</template>
        </TableItem>
        <TableItem title="失业保险" align="right">
          <template slot-scope="{data}">{{ money(data.unemployment) }}</template>
        </TableItem>
        <TableItem title="工伤保险" align="right">
          <template slot-scope="{data}">{{ money(data.injury) }}</template>
        </TableItem>
        <TableItem title="单位应缴合计" align="right">
          <template slot-scope="{data}"><b>{{ money(data.totalAmount) }}</b></template>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShbxGdDeclare',
  data() {
    let now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      loading: false,
      submitting: false,
      rows: [],
      //广东参考单位费率
      rates: {pension: 0.14, medical: 0.055, unemployment: 0.008, injury: 0.002}
    };
  },
  methods: {
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    doPreview() {
      if (!this.year || !this.month) {
        this.$Message.warning('请选择费款所属年月');
        return;
      }
      this.loading = true;
      this.$api.pro.social.preview({
        region: 'GD', year: this.year, month: this.month, rates: this.rates
      }).then(({data}) => {
        this.rows = data.results || [];
      }).finally(() => this.loading = false);
    },
    doSubmit() {
      if (!this.rows.length) {
        this.$Message.warning('请先进行申报预览');
        return;
      }
      this.$Confirm(`确认向广东税务云提交 ${this.year}年${this.month}月社保费申报？共 ${this.rows.length} 人。`).then(() => {
        this.submitting = true;
        this.$api.pro.social.submit({
          region: 'GD', year: this.year, month: this.month, rates: this.rates
        }).then(() => {
          this.$Message.success('广东社保费申报提交成功');
          this.doPreview();
        }).finally(() => this.submitting = false);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 10px;
}
</style>
